import type { ReactNode } from "react";

import * as styles from "./SkipLink.module.scss";

export interface SkipLinkProps {
	/** The fragment of the element to jump to, e.g. `#main-content`. */
	href: `#${string}`;
	children: ReactNode;
}

export function SkipLink({ href, children }: SkipLinkProps): JSX.Element {
	return (
		<a
			href={href}
			className={styles["skip-link"]}
			data-component="SkipLink"
		>
			{children}
		</a>
	);
}
